exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js
// module id = LUWG
// module chunks = 21